import { ca } from '@cian/analytics';

export type TCpdDealsLeadSource = 'magazineForm' | 'magazineBanner';

interface ICpdDealsEventParams {
  action: string;
  label?: string;
  form?: string;
  category?: string;
  extra?: Record<string, unknown>;
}

const EXTRA_CPD_PRODUCT = { product: 'CPD' };
const EXTRA_MAGAZINE_FORM = { source: 'magazineForm' };

export const createCpdDealsEvent = ({ category = 'Magazine', extra, ...params }: ICpdDealsEventParams) => {
  return (runtimeExtra?: Record<string, unknown>) => {
    ca('eventSite', {
      name: 'oldevent',
      category,
      ...params,
      page: {
        extra: {
          ...extra,
          ...runtimeExtra,
        },
      },
    });
  };
};

export const caShowCpdBanner = createCpdDealsEvent({
  action: 'Show_sopr',
  label: 'banner',
  extra: EXTRA_CPD_PRODUCT,
});

export const caShowCpdForm = createCpdDealsEvent({
  action: 'Show_sopr',
  label: 'form',
  extra: EXTRA_CPD_PRODUCT,
});

export const caClickCpdBanner = createCpdDealsEvent({
  action: 'click',
  label: 'banner',
  extra: EXTRA_CPD_PRODUCT,
});

export const caOpenCpdPopupForm = createCpdDealsEvent({
  category: 'DemandCpd',
  action: 'Open',
  label: 'Popup',
  extra: EXTRA_MAGAZINE_FORM,
});

export const caClickSendCpd = createCpdDealsEvent({
  category: 'DemandCpd',
  action: 'Click',
  label: 'Send',
});

export const caSendSuccessCpd = createCpdDealsEvent({
  category: 'DemandCpd',
  action: 'Send',
  label: 'Success',
});

export const caShowCpdFail = createCpdDealsEvent({
  category: 'DemandCpd',
  action: 'Show_sopr',
  label: 'Fail',
});
